import React, { Component } from 'react';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import Slider from 'react-slick';
import { presetDp } from '../../../utils/shared.js';
import BRSpan from '../../General/BRSpan';
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class StorySeattle extends Component {
  constructor(props) {
    super(props);
    this._imagesStatus = [];
    this._contentRef = null;
  }

  componentDidMount() {
    this.intervalCheckSwipeAnimation();
  }

  intervalCheckSwipeAnimation = () => {
    if (!this._contentRef) {
      setTimeout(() => {
        this.intervalCheckSwipeAnimation();
      }, 100);
    } else {
      this.checkSwipeAnimation();
    }
  }

  checkSwipeAnimation = () => {
    let scrollWrapperHeight = 0.14625 * this.props.regionWidth;
    let contentHeight = this._contentRef.getBoundingClientRect().height;
    this.props.handleSwipeAnimation(scrollWrapperHeight, contentHeight);
  }

  handleScrollStart = () => {
    this.props.cancelSwipeAnimation();
  }

  getSlides = () => {
    let images = this.props.item.contents.images;
    let occupiedSlots = _.filter(images, (img) => {
      return (img !== null)
    });
    let slides = [];

    for (let i = 0; i < occupiedSlots.length; i++) {
      if (occupiedSlots[i]) {
        this._totalSlides++;
      }
    }
    
    if (occupiedSlots.length > 0) {
      slides = occupiedSlots.map((media, i) => {
        let imgSrc = presetDp('story', media, this.props.screen);
        if (media) {
          return (
            <div key={i} style={{ display:"table" }}>
              <div style={{ display:"table-cell", verticalAlign:"middle", height:0.21375 * this.props.regionWidth }}>
                <img style={{ maxWidth:0.28125 * this.props.regionWidth, maxHeight:0.2025 * this.props.regionWidth, display:"table-cell", verticalAlign:"middle", margin:"auto" }} src={imgSrc} onLoad={() => this._imagesStatus[i] = true} onError={() => this._imagesStatus[i] = false} alt=""/>
              </div>
            </div>
          );
        }

        return <span />;
      });
    }

    return slides;
  }

  render() {
    let settings = {
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      useCSS: true,
      dots: true,
      dotsClass: "story-seattle-slick",
    };

    let slides = this.getSlides();
    if (slides.length <= 1) {
      settings.dots = false;
    }
    
    let textOps = _.get(this.props.item.contents, 'custom_fields.body.val.ops', {});
    let converter = new QuillDeltaToHtmlConverter(textOps, {}); 
    let richText = converter.convert();
    
    return (
      <div style={{ position:"absolute", display:"table", height:"100%", width:"100%" }}>
        <div style={{ display:"table-cell", verticalAlign:"middle" }}>
          <div style={{ position:"relative", width:"100%", alignItems:"center", display:"flex", justifyContent:"center", textAlign:"center", minHeight:.027 * this.props.regionWidth, maxHeight: .10 * this.props.regionWidth, overflow:"hidden" }}>
            <span className="noselect" style={{ fontSize: 0.016875 * this.props.regionWidth, width:"65%" }}><BRSpan preWrap str={this.props.item.name.toUpperCase()} /></span>
          </div>
          {
            slides.length === 0 ? 
            null:
            <div style={{ position:"relative", width:"100%", height:0.2475 * this.props.regionWidth, display:"flex" }}>
              <div style={{ position:"relative", width:0.30375 * this.props.regionWidth, margin:"auto" }}>
                <Slider ref={el => this._slickRef = el} {...settings}>
                  {slides}
                </Slider>
              </div>
            </div>
          }

          <div className="gradient" style={{ position: "relative", height: 0.14625 * this.props.regionWidth, width: "100%", touchAction: "none", marginTop: .009 * this.props.regionWidth }}>
            <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
              onScrollStart={this.handleScrollStart}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.015,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
                tap: true
              }}
            >
              <div style={{ position: "relative", display: "flex", justifyContent: "center" }} ref={el => this._contentRef = el}>
                <div style={{ width: 0.30375 * this.props.regionWidth, display: "flex" }}>
                  <span style={{ fontSize: 0.01125 * this.props.regionWidth, textAlign: "left", lineHeight: 0.0225 * this.props.regionWidth + "px", color: "white" }}>
                    <div className="ql-editor noselect" dangerouslySetInnerHTML={{ __html: richText }}></div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </div>
              </div>
            </ReactIScroll>
          </div>
          
        </div>
      </div>
    );
  }
}

export default StorySeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/StorySeattle.jsx